
export default {
  name: 'PageNewsIndex',

  head() {
    return {
      title: 'Latest news and blog posts',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'All the latest news and blog posts from Paw Paddock'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Latest news and blog posts',
        image: require('~/assets/images/backgrounds/news-hero-2.jpg'),
        alt: '3 dogs at the feet of their owners'
      }
    }
  }
}
